import Meaning from './Meaning';
import Parser from 'html-react-parser';
const returnJSX = (content) => {
    if (!content) {
        return (<></>)
    }
    else {
        let stringArray = content.split("[");
            // console.log(content);
        if (stringArray.length > 1) {
            let wordSplit = stringArray[1].split("]");
            let word = wordSplit[0].split("::")[0]
            let meaning = wordSplit[0].split("::")[1]
            
            return (
                <>
                    {Parser(stringArray[0].replace("most to least","<strong>most to least</strong>").replace("highest to smallest","<strong>highest to smallest</strong>"))} &nbsp;
                    <Meaning
                        content={meaning}
                        word={word}
                    /> 
                    {Parser(wordSplit[1].replace("most to least","<strong>most to least</strong>").replace("highest to smallest","<strong>highest to smallest</strong>"))}
                </>
            )
        }
        else {
            return (
                <>
                    {Parser(content.replace("most to least","<strong>most to least</strong>").replace("highest to smallest","<strong>highest to smallest</strong>"))}
                </>
            )
        }
    }
}

export default returnJSX;